import React, { useEffect, useState} from 'react';
import SideMenu from '../sideMenu'; 
import DashboardHeader from '../topbar';
import Styles from "./styles.module.scss";
import * as CONSTANTS from '../../utils/CONSTANTS'
import { makeSideBarActive } from '../../utils/EllowUtils';
import { TabStrip } from "@progress/kendo-react-layout";
import Tab from '../../components/tab';
import ResourcesTable from './allResources';
import {
  TabStripSelectEventArguments,
} from "@progress/kendo-react-layout";
import { getCandidates } from './services'
import { viewedpageMixpanel } from '../../utils/mixpanel';
import { getAPI } from '../../api';


function Resources() {

  const menu = makeSideBarActive(CONSTANTS.sideMenu, 1)
  let BreadcrumsValues = ['Resources']

  const customerId = localStorage.getItem('customerId')
  const [selectedTab, setSelectedTab] = useState<number>(0);
  const [total, setTotal] = useState<number>()
  const [resources, setResources] = useState<any>()
  localStorage.removeItem('candidateLoginId');
  const loginId = localStorage.getItem('loginId')
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [search, setSearch] = useState<string>('');
  const [filterValues, setFilterValues] = useState<any>();
  const [sort, setSort] = useState<any>([]);
  const [skillList, setSkillList] = useState<any>()


  const findTabName = (value: number) => {
    switch(value){

      case 0:
        return 'providerResource';
      case 1:
        return 'providerDraft';
      default:
        return ''
    }
  }

  
  useEffect(() => {

    getResources( 0, 25, 1, '')
    viewedpageMixpanel()

    getAPI('https://api.ellow.io/common/api/v1/ml/skills').then((value: any) => {
      if (value && value.status === 1) {
        setSkillList(value.data)
      }
    })


  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSelectedTab(e.selected)
    
  }

  const pageChange = (pageSize: number, pageNumber: number) => {
    let page = pageNumber !== 0 ? Math.floor(pageNumber / pageSize) + 1 : 1; 
    
  
    getResources( 0, pageSize, page, search)
  
    
    }


  const getResources = (tabValue: number, pageSize: number, pageNumber: number, searchValue: string, filters?: any, sort?: any) => {
    let tabName = findTabName(tabValue)

    let body ={}
  
    if (filters) {
      filters.loginId = loginId
      filters.behalf_of = {
        id: customerId,
        name: 'Nidhin Babu'
      }
      filters.coreSkillsCombination = filters.coreSkillsCombination && filters.coreSkillsCombination.id
      body = {
        filters,
        sort: sort && sort.length > 0 ? {
          sortBy:sort[0].field,
          sortOrder:sort[0].dir
        } : undefined
      }
    }
    else {
      body = {
        filters: {
          loginId: loginId,
          behalf_of: {
            id: customerId,
            name: 'Nidhin Babu'
          }
        },
        sort: sort && sort.length ? {
          sortBy:sort[0].field,
          sortOrder:sort[0].dir
        } :  undefined
      }
    }
    
    getCandidates(tabName, pageSize, pageNumber, searchValue, body ).then((response) => {
      if (response && response.status === 1) {
            setResources(response.data)
            setTotal(response.count)     
      }
    });
  };

  const getResourceTables = () => {

    getResources( 0, 25, 1, search, sort)

 }
 

 const AllResourceTab = <>All Resources <i>{total}</i></>
  
  const applyFilter = (data: any) => {
    getResources(0, 25, 1, '', data)
    delete data.behalf_of;
    setFilterValues(data)

};

const closeTag = (data: any) => {
  applyFilter(data)
  }
  
const searchChange = (e: string) => {

getResources(0, 25, 1, e, sort)

};


const applySort = (sort: any) => {
  getResources(0, 25, 1, '', filterValues , sort)
};



  return (
    <section className="dashboardWrapper">
      <SideMenu menu={menu} openresource={'allresources'} />
      <div className="dashboardContent">
      <DashboardHeader
          title={BreadcrumsValues}
          applyResourceFilter={applyFilter}
          type='resources'
          filterValues={filterValues}
          searchChange={searchChange}
          closeTag={closeTag}
          skillsList={skillList}
                 />
     
        <section className={Styles.dashboardWrapper}>
          <TabStrip selected={selectedTab} onSelect={handleSelect}>
              <Tab title={AllResourceTab} >
                  <ResourcesTable data={resources} getTablesValues={getResourceTables} total={total} pageSize={pageChange} setSort={setSort} applySort={applySort}/>
              </Tab>
          </TabStrip>
        </section>
      </div>
    </section>
  )
}

export default Resources
